import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from '../../components/Loading';

const ProjectInvitationPage = lazy(
  () =>
    import(
      /* webpackChunkName: "project-invitation" */ '../../pages/project-invitation'
    ),
);

const projectInvitationRouter = (
  <Route
    path="project-invitation"
    element={
      <Suspense fallback={<Loading />}>
        <ProjectInvitationPage />
      </Suspense>
    }
  />
);

export default projectInvitationRouter;
